<template>
  <v-menu
    v-model="menuOpen"
    class="sw-date-picker-field-menu"
    :close-on-content-click="false"
    transition="scale-transition"
    :offset="offset"
    location="bottom start"
    content-class="sw-date-picker-menu"
  >
    <template #activator="{ props: menuProps }">
      <v-text-field
        v-bind="{ ...menuProps, ...$attrs }"
        :model-value="displayValue"
        :label="label"
        :density="density"
        :variant="variant"
        :hide-details="hideDetails"
        :style="fieldStyle"
        readonly
        color="primary"
        prepend-inner-icon="mdi-calendar"
        :class="fieldClasses"
        @click:clear="clearValue"
      />
    </template>

    <SwDatePicker
      :model-value="modelValue"
      :min="min"
      :max="max"
      :type="type"
      :title="pickerTitle"
      :show-presets="showPresets"
      :immediate="immediate"
      @apply="onApply"
      @cancel="onCancel"
    />
  </v-menu>
</template>

<script>
import SwDatePicker from "./SwDatePicker.vue";

export default {
  name: "SwDatePickerField",

  components: { SwDatePicker },

  inheritAttrs: false,

  props: {
    modelValue: { type: [String, Date], default: null },
    label: { type: String, default: "Select Date" },
    placeholder: { type: String, default: undefined },
    min: { type: [String, Date, Number], default: undefined },
    max: { type: [String, Date], default: undefined },
    type: { type: String, default: "date" },
    pickerTitle: { type: String, default: "Select Date" },
    showPresets: { type: Boolean, default: true },
    immediate: { type: Boolean, default: false },
    density: { type: String, default: "comfortable" },
    variant: { type: String, default: "outlined" },
    hideDetails: { type: Boolean, default: true },
    fieldStyle: { type: [String, Object], default: undefined },
    offset: { type: [Number, String, Array], default: 8 },
    displayFormatter: { type: Function, default: null },
  },

  emits: ["update:modelValue", "apply", "cancel", "clear"],

  data() {
    return {
      menuOpen: false,
    };
  },

  computed: {
    fieldClasses() {
      const attrClass = this.$attrs.class;
      const usesFilterControl =
        (typeof attrClass === "string" && attrClass.includes("tad-control")) ||
        (Array.isArray(attrClass) && attrClass.some((c) => String(c).includes("tad-control")));

      return usesFilterControl
        ? ["sw-date-field"]
        : ["sw-float-field", "sw-date-field"];
    },

    displayValue() {
      if (!this.modelValue) return "";
      if (this.displayFormatter) return this.displayFormatter(this.modelValue);

      if (this.type === "month") {
        const [year, month] = String(this.modelValue).split("-");
        if (!year || !month) return String(this.modelValue);
        const date = new Date(Number(year), Number(month) - 1, 1);
        return date.toLocaleDateString(undefined, {
          month: "short",
          year: "numeric",
        });
      }

      const date = new Date(`${String(this.modelValue).split("T")[0]}T00:00:00`);
      if (Number.isNaN(date.getTime())) return String(this.modelValue);

      return date.toLocaleDateString(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
  },

  methods: {
    onApply(value) {
      this.$emit("update:modelValue", value);
      this.$emit("apply", value);
      this.menuOpen = false;
    },

    onCancel() {
      this.$emit("cancel");
      this.menuOpen = false;
    },

    clearValue() {
      this.$emit("update:modelValue", null);
      this.$emit("clear");
    },
  },
};
</script>
